import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UpOSS = function (_NebulaModuleBase) {
    _inherits(UpOSS, _NebulaModuleBase);

    function UpOSS() {
        _classCallCheck(this, UpOSS);

        return _possibleConstructorReturn(this, (UpOSS.__proto__ || Object.getPrototypeOf(UpOSS)).apply(this, arguments));
    }

    _createClass(UpOSS, [{
        key: 'aliyunOSSInit',
        value: function aliyunOSSInit(data) {
            return this.generatePromiseByFunctionWithParams('initOSS', data);
        }
    }, {
        key: 'uploadFilesByAliyunOSS',
        value: function uploadFilesByAliyunOSS(data) {
            var event = 'publishProgress' + data.uploadId;
            var params = {
                eventName: event,
                param: data
            };
            return this.generatePromiseByAttachListenerWithParams(event, data.progress, 'uploadFilesByOSS', params);
        }
    }, {
        key: 'downloadFilesByAliyunOSS',
        value: function downloadFilesByAliyunOSS(data) {
            var event = 'publishProgress' + data.uploadId;
            var params = {
                eventName: event,
                param: data
            };
            return this.generatePromiseByAttachListenerWithParams(event, data.progress, 'downloadFilesByOSS', params);
        }
    }, {
        key: 'deleteFilesByAliyunOSS',
        value: function deleteFilesByAliyunOSS(data) {
            return this.generatePromiseByFunctionWithParams('deleteFilesByOSS', data);
        }
    }]);

    return UpOSS;
}(NebulaModuleBase);